<div class="jumbotron">
    <h1 class="display-4">Access denied</h1>
    <p class="lead">You do not have access to the Submission Platform</p>
    <hr class="my-4">
    <p>If you want to be added to the application, please request access below.</p>
    <p class="lead">
        <a class="btn btn-primary btn-lg" role="button" (click)="requestAccess()">Request Access</a>
    </p>
</div>